// Utilities --> CHANGE NAME TO USER PREFERENCE OR PARAMETER ?
import { make } from 'vuex-pathify'
import axios from 'axios'
import auth from './authentification'
import message from './messages'

// Globals
import { IN_BROWSER } from '@/util/globals'

const state = {
  dark: false,
  drawer: {
    image: 0,
    gradient: 0,
    mini: false,
  },
  gradients: [
    'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
    'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
  ],
  images: [
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-2.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-3.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-4.jpg',
  ],
  notifications: [],
  rtl: false,
}

const mutations = make.mutations(state);

const actions = {
  fetch: ({ commit }) => {
    const local = localStorage.getItem('vuetify@user') || '{}'
    const user = JSON.parse(local)

    for (const key in user) {
      commit(key, user[key])
    }

    if (user.dark === undefined) {
      commit('dark', window.matchMedia('(prefers-color-scheme: dark)'))
    }
  },
  update: ({ state }) => {
    if (!IN_BROWSER) return

    localStorage.setItem('vuetify@user', JSON.stringify(state))
  },
}

const getters = {
  dark: (state, getters) => {
    return (
      state.dark ||
      getters.gradient.indexOf('255, 255, 255') === -1
    )
  },
  gradient: state => {
    return state.gradients[state.drawer.gradient]
  },
  image: state => {
    return state.drawer.image === '' ? state.drawer.image : state.images[state.drawer.image]
  },
}

//USER RIGHT MANAGEMENT

state.userList = [];

mutations.setUserList = function(state, payload) {
  state.userList = payload;
};

actions.getUserList = function({ state, commit }) {
  try{
      axios.get(`/api/user_list`).then(response => {
      commit('setUserList', response.data);
    }); 
  } catch(error){
    commit('setUserList', []);
  }
};

actions.register = function({ commit, dispatch }, payload) {
   axios.post('/api/signup', payload).then(
      response => {
        message.mutations.setConfirmationAdd(message.state, true);
        dispatch('getUserList');
        return Promise.resolve(response.data);
      },
      error => {
        dispatch('getUserList');
        return Promise.reject(error);
      }
  );
};

actions.updateUser = function({ state, commit, dispatch }, payload) {
  try{

      //payload.username = auth.state.username; 

      axios.post(`/api/update_user`, payload).then(response => {
        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getUserList');
      }); 
  } catch(error){
    message.mutations.setErrorMessage(message.state, true);
    commit('getUserList', []);
  }
};

actions.deleteUser = function({ state, commit, dispatch }, payload) {
  try{

    var request = {
        id: payload,
        username : auth.state.username
      }

    //axios.post(`/api/delete_user`,{id: payload}).then(response => {
    axios.post(`/api/delete_user`, request).then(response => {
      message.mutations.setConfirmationDelete(message.state, true);
      dispatch('getUserList');
    });
  } catch(error){
    message.mutations.setErrorMessage(message.state, true);
    commit('getUserList', []);
  }
}

getters.userList = function(state){
    return state.userList
  };

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
